import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import Label from './common/label';

const ChannelOrgCode = ({ labels, errors, touched }) => {
  return (
    <>
      <Label labelName={labels.CHANNEL_ORGANIZATION_CODE} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.channelOrgCode && touched.channelOrgCode ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_CHANNEL_ORGANIZATION_CODE}
          name="channelOrgCode"
          className="select-style"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.channelOrgCode}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

ChannelOrgCode.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default ChannelOrgCode;
